import SplashComponent from "./splash-component";

export default SplashComponent